import { Checkbox } from 'components/atoms/form/Checkbox.tsx';
import { localize } from 'i18n/localize.ts';
import type { JSX } from 'preact';
import { MultiselectOfferSignal } from 'components/bazar/signals.ts';
import { cn } from 'utils/cn';

export type Props = {
	className?: string;
	signal: MultiselectOfferSignal;
	offerId: number;
	multiselectInputProps?: Record<string, unknown>;
	onClickCallback: (event: JSX.TargetedMouseEvent<HTMLInputElement>, offerId: number) => void;
};

const $t = localize();

export function MultiselectCheckbox({ className, signal, offerId, multiselectInputProps, onClickCallback }: Props) {
	return signal.value.enabled ? (
		<div class={cn('leading-0 bg-dark-blue-50 rounded-lg', className)}>
			<Checkbox
				color="white"
				className="p-[7px]"
				title={$t.offer.multiselect}
				inputProps={{
					...(multiselectInputProps || {}),
					onClick: (event) => {
						onClickCallback(event, offerId);
					},
					checked: Boolean(offerId) && signal.value.selectedOffers.has(offerId),
				}}
			/>
		</div>
	) : (
		<div></div>
	);
}
